// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stats_wrapper__12jJV","lives":"Stats_lives__25zoT"};